import React, { FunctionComponent } from 'react';
import { BridgeType, StepList, StepListProps, StepListTitle } from '../../styles/StepList';
import { PresentationLayout } from './PresentationLayout';

export type ScreenshotLayoutConfig = {
  title?: string;
  image: string;
  imageAltText: string;
  listTitle: string;
  listItems: StepListProps['items'];
  primaryButtonTitle: string;
  textAnimationEnabled?: boolean;
};

type ScreenshotLayoutProps = ScreenshotLayoutConfig & {
  onPressPrimaryButton: () => void;
};

export const ScreenshotLayout: FunctionComponent<ScreenshotLayoutProps> = (props) => {
  const {
    title,
    image,
    imageAltText,
    listTitle,
    listItems,
    primaryButtonTitle,
    onPressPrimaryButton,
    textAnimationEnabled = false,
  } = props;

  return (
    <PresentationLayout
      title={title}
      content={[{ type: 'image', src: image, altText: imageAltText }]}
      buttonHook={[
        {
          type: 'custom',
          content: (
            <>
              <StepListTitle bold animationEnabled={textAnimationEnabled} animationIndex={0}>
                {listTitle}
              </StepListTitle>
              <StepList bridgeType={BridgeType.Plus} items={listItems} />
            </>
          ),
        },
      ]}
      primaryButtonTitle={primaryButtonTitle}
      onPressPrimaryButton={onPressPrimaryButton}
      textAnimationEnabled={textAnimationEnabled}
    />
  );
};
